import { takeLatest, all, put, fork, call } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { postContoCorrente } from '../../../api/contoCorrenteApi'
import {push} from "connected-react-router";

export default function* contoCorrenteCreateSaga() {
    yield all([
        fork(watchSaveContoCorrenteCreateRequest),
        fork(watchCreateContoCorrenteNoteFiledChangeRequest),
        fork(watchCreateContoCorrenteContoCorrenteFiledChangeRequest),
        fork(watchCreateContoCorrenteSenderAccountFiledChangeRequest),
        fork(watchCreateContoCorrenteCleanRequest)
    ]);
}

function* watchSaveContoCorrenteCreateRequest() {
    yield takeLatest(
        actions.SAVE_CONTO_CORRENTE_CREATE_REQUEST,
        saveContoCorrenteCreateRequest
    )
}

function* saveContoCorrenteCreateRequest(contoCorrenteData) {
    yield put({type: actions.CLEAN_ERROR})
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(postContoCorrente,contoCorrenteData.value.bankId, contoCorrenteData.value.contoCorrente)
        yield put({ type: actions.SAVE_CONTO_CORRENTE_CREATE_SUCCESS, value: data })
        yield put({ type: actions.CREATE_CONTO_CORRENTE_CLEAN_REQUEST })
        let bankId = contoCorrenteData.value.contoCorrente.bankId
        let corporate = contoCorrenteData.value.contoCorrente.corporate
        yield put({ type: actions.FETCH_CORPORATE_EDIT_REQUEST, value: {bankId, corporate} })
        yield put(push(`/corporate/edit/${contoCorrenteData.value.contoCorrente.corporate}`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.SAVE_CONTO_CORRENTE_CREATE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
        }
    }
}

function* watchCreateContoCorrenteCleanRequest() {
    yield takeLatest(
        actions.CREATE_CONTO_CORRENTE_CLEAN_REQUEST,
        createContoCorrenteCleanRequest
    )
}

function* createContoCorrenteCleanRequest() {
    yield put({ type: actions.CREATE_CONTO_CORRENTE_CLEAN })
}

function* watchCreateContoCorrenteNoteFiledChangeRequest() {
    yield takeLatest(
        actions.CREATE_CONTO_CORRENTE_NOTE_FILED_CHANGE_REQUEST,
        createContoCorrenteNoteFiledChangeRequest
    )
}

function* createContoCorrenteNoteFiledChangeRequest(note) {
    yield put({ type: actions.CREATE_CONTO_CORRENTE_NOTE_FILED_CHANGE, value: note.value })
}

function* watchCreateContoCorrenteContoCorrenteFiledChangeRequest() {
    yield takeLatest(
        actions.CREATE_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE_REQUEST,
        createContoCorrenteContoCorrenteFiledChangeRequest
    )
}

function* createContoCorrenteContoCorrenteFiledChangeRequest(contoCorrente) {
    yield put({ type: actions.CREATE_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE, value: contoCorrente.value })
}

function* watchCreateContoCorrenteSenderAccountFiledChangeRequest() {
    yield takeLatest(
        actions.CREATE_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE_REQUEST,
        createContoCorrenteSenderAccountFiledChangeRequest
    )
}

function* createContoCorrenteSenderAccountFiledChangeRequest(senderAccount) {
    yield put({ type: actions.CREATE_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE, value: senderAccount.value })
}